import React, { useState } from 'react';
import FontSizeOption from '../app/components/blocks/FontSizeOption.jsx';
import Modal from '../commons/components/Modal.jsx';
import { TryNowAnswer } from '../app/components/pages/PageTryNow.jsx';

import { subjects } from '../../../../components/quiz/config/subjects';
import { getLang } from '../commons/helpers';

const LoginComponent = () => (
  <div className="d-flex align-items-center">
    <img
      src="/assets/img/userInfo.svg"
      alt="User Icon"
      className="d-block"
      style={{ width: 32, height: 32 }}
    />
    <span
      style={{
        fontSize: '16px',
        marginLeft: '8px',
        fontWeight: 400,
        color: '#DE6400',
      }}
    >
      未登錄
    </span>
  </div>
);

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const currentPath = window.location.pathname;
  const [show, setShow] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(null);

  const links = [
    { to: '/announcements', children: '公告欄', icon: 'announcement.svg' },
    { to: '/intro', children: '計劃介紹', icon: 'intro.svg' },
    { to: '/schedule', children: '計劃日程', icon: 'schedule.svg' },
    {
      children: '熱身專區',
      icon: 'training.svg',
      onPress: () => setShow(true),
    },
    { to: '/register', children: '報名方法', icon: 'signUp.svg' },
    { to: '/qa', children: '常見問題', icon: 'qa.svg' },
    { to: '/contactUs', children: '聯絡我們', icon: 'contactUs.svg' },
  ];

  const toggleMobileMenu = (e) => {
    // e.preventDefault();
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const isActive = (linkTo) => currentPath === linkTo;

  const getIconSrc = (link) => {
    if (isActive(link.to)) {
      // Replace .svg with -active.svg for active state
      return `/assets/img/${link.icon.replace('.svg', '-active.svg')}`;
    }
    return `/assets/img/${link.icon}`;
  };

  return (
    <nav className="header-nav py-3 bg-white">
      <div className="container-fluid">
        {/* First row: logos - show all on mobile too */}
        <div className="d-flex d-md-none row align-items-center mb-2">
          <div className="col p-1">
            <img
              src="/assets/img/boc_mobile_new.svg"
              alt="中國銀行(香港)"
              className="d-block nav-boc-img"
            />
          </div>
          <div className="col-auto p-1 nav-title-text">呈獻</div>
          <div className="col p-1">
            <img
              src="/assets/img/logo.svg"
              alt="Academy"
              className="d-block nav-logo-img"
            />
          </div>
        </div>
        <div className="d-none d-md-flex row align-items-center mb-2">
          <div className="col-12 d-flex flex-row justify-content-between align-items-center">
            {/* Left side logos */}
            <div className="d-flex align-items-center gap-2 gap-lg-4">
              <div className="d-flex align-items-center gap-2 text-nowrap">
                <img
                  src="/assets/img/boc_mobile_new.svg"
                  alt="中國銀行(香港)"
                  className="d-block nav-boc-img"
                />
                <div className="col-auto p-1 nav-title-text">呈獻</div>
              </div>
            </div>
            {/* Center logos */}
            <div className="d-flex align-items-center justify-content-center">
              <a href="/">
                <img
                  src="/assets/img/logo.svg"
                  alt="Academy"
                  className="d-block nav-img"
                />
              </a>
            </div>
            {/* Right side logos - responsive sizing */}
            <div className="d-none d-lg-flex align-items-center gap-1 gap-xl-2 gap-xxl-4">
              <div className="d-flex align-items-center gap-1">
                <img
                  src="/assets/img/aocs.svg"
                  alt="中華文化教育"
                  className="d-block"
                  style={{ width: 'auto' }}
                />
                <span
                  className="d-none d-xl-inline"
                  style={{ fontSize: '14px', marginLeft: '4px' }}
                >
                  主辦
                </span>
              </div>
              <div className="mx-1 mx-xl-2 mx-xxl-3"></div>
              <div className="d-flex align-items-center gap-1">
                <img
                  src="/assets/img/edb.svg"
                  alt="香港特別行政區政府教育局"
                  className="d-block"
                  style={{ width: 'auto' }}
                />
                <span
                  className="d-none d-xl-inline"
                  style={{ fontSize: '14px', marginLeft: '4px' }}
                >
                  支持
                </span>
              </div>
            </div>
            {/* Mobile spacer to maintain balance */}
            <div className="d-lg-none" style={{ width: 60 }}></div>
          </div>
        </div>

        {/* Mobile nav: show for screens up to 1130px */}
        <div className="row align-items-center mb-2 d-xl-none">
          <div className="col-12 d-flex justify-content-between align-items-center">
            {/* Left - Hamburger menu button */}
            <div>
              <button
                className="btn btn-link nav-toggle"
                onClick={toggleMobileMenu}
                style={{ fontSize: '1.5rem', color: '#FF831E' }}
              >
                &#9776;
              </button>
            </div>

            {/* Right - LoginComponent */}
            <div>
              <LoginComponent />
            </div>
          </div>
        </div>

        {/* Desktop nav: show for screens above 1130px */}
        <div className="d-none d-xl-flex row align-items-center">
          <div className="col-12 d-flex flex-column flex-xl-row justify-content-xl-between align-items-center">
            {/* Left spacer - desktop only */}
            <div className="d-none d-xl-block"></div>

            {/* Center nav links */}
            <nav className="nav nav-pills flex-column flex-xl-row mb-3 mb-xl-0">
              {links.map((link) => {
                const linkHref = link.onPress ? undefined : link.to;

                return (
                  <a
                    key={link.to || link.children}
                    className="nav-link rounded-pill py-2 text-center d-flex align-items-center"
                    href={linkHref}
                    onClick={link.onPress ? link.onPress : undefined}
                    style={{ cursor: 'pointer' }}
                  >
                    <img
                      src={getIconSrc(link)}
                      alt={link.children}
                      className="d-block"
                      style={{ width: 32, height: 32 }}
                    />
                    <span
                      style={{
                        fontSize: '16px',
                        marginLeft: '8px',
                        fontWeight: 400,
                        color: isActive(link.to) ? '#FF831E' : 'inherit',
                      }}
                    >
                      {link.children}
                    </span>
                  </a>
                );
              })}
            </nav>

            {/* Right controls */}
            <div className="d-flex flex-column flex-lg-row align-items-center gap-3">
              <LoginComponent />
              <div className="d-flex align-items-center">
                <span id="font-size-option">
                  <FontSizeOption />
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Training Modal */}
        {show && (
          <Modal
            show={show}
            onHide={() => setShow(false)}
            size="lg"
            centered={false}
            className="grade-select-modal"
            closeButton={false}
          >
            <div className="modal-header border-0 pb-0">
              <div className="d-flex justify-content-center w-100">
                <img src="/assets/img/trainingWord.svg" alt="training" />
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShow(false)}
              >
                <img src="/assets/img/closeBtn.svg" style={{ height: 39 }} />
              </button>
            </div>
            <div className="modal-body p-2 p-md-4">
              <div className="row g-2 g-md-4">
                <div className="col-12 col-md-6 mb-3 mb-md-0">
                  <div
                    className="green-border h-100 rounded-4"
                    style={{
                      backgroundColor: 'white',
                      minHeight: '200px',
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '15px',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      className="text-center mb-3"
                      style={{
                        color: '#008A48',
                        fontSize: 'clamp(18px, 4vw, 24px)',
                        fontWeight: '700',
                        borderRadius: '20px',
                      }}
                    >
                      我是初小生
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="dropdown-container">
                        <select
                          className="form-select rounded-pill text-center"
                          style={{
                            backgroundColor: 'white',
                            fontSize: 'clamp(14px, 3vw, 16px)',
                            padding: '8px 25px 8px 15px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            border: '1px solid #94CF6E',
                            color: '#008A48',
                          }}
                          onChange={(evt) => {
                            if (evt.target.value) {
                              setSelectedOptions({
                                subject: evt.target.value,
                                isSenior: false,
                              });
                              setShow(false);
                            }
                          }}
                          onClick={(evt) => evt.stopPropagation()}
                        >
                          <option value="">選擇閱讀材料</option>
                          {Object.keys(subjects).map((key) => (
                            <option key={key} value={key}>
                              {getLang(subjects[key], 'zh')}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div
                    className="blue-border h-100 rounded-4"
                    style={{
                      backgroundColor: 'white',
                      minHeight: '200px',
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '15px',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      className="text-center mb-3"
                      style={{
                        color: '#1964BA',
                        fontSize: 'clamp(18px, 4vw, 24px)',
                        fontWeight: '700',
                        borderRadius: '20px',
                      }}
                    >
                      我是高小生
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="dropdown-container">
                        <select
                          className="form-select rounded-pill text-center"
                          style={{
                            backgroundColor: 'white',
                            fontSize: 'clamp(14px, 3vw, 16px)',
                            padding: '8px 25px 8px 15px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            border: '1px solid #1964BA',
                            color: '#1964BA',
                          }}
                          onChange={(evt) => {
                            if (evt.target.value) {
                              setSelectedOptions({
                                subject: evt.target.value,
                                isSenior: true,
                              });
                              setShow(false);
                            }
                          }}
                          onClick={(evt) => evt.stopPropagation()}
                        >
                          <option value="">選擇閱讀材料</option>
                          {Object.keys(subjects).map((key) => (
                            <option key={key} value={key}>
                              {getLang(subjects[key], 'zh')}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        )}

        {selectedOptions && (
          <TryNowAnswer
            subject={selectedOptions.subject}
            isSenior={selectedOptions.isSenior}
            show={true}
            onHide={() => {
              setSelectedOptions(null);
            }}
          />
        )}

        {/* Mobile menu overlay: show for screens up to 1130px */}
        {isMobileMenuOpen && (
          <div
            className="position-fixed w-100 h-100 bg-white d-xl-none"
            style={{
              top: 0,
              left: 0,
              zIndex: 99999,
              overflowY: 'auto',
            }}
          >
            <div className="header-nav bg-white">
              <div className="container-fluid">
                {/* First row: boc and logo - mobile only */}
                <div className="d-flex d-md-none row align-items-center mb-2">
                  <div className="col p-1">
                    <img
                      src="/assets/img/boc_mobile_new.svg"
                      alt="中國銀行(香港)"
                      className="d-block nav-boc-img"
                    />
                  </div>
                  <div className="col-auto p-1 nav-title-text">呈獻</div>
                  <div className="col p-1">
                    <img
                      src="/assets/img/logo.svg"
                      alt="Academy"
                      className="d-block nav-logo-img"
                    />
                  </div>
                </div>
                {/* First row: logos - tablet/desktop */}
                <div className="d-none d-md-flex row align-items-center mb-2">
                  <div className="col-12 d-flex flex-row justify-content-between align-items-center">
                    {/* Left side logos */}
                    <div className="d-flex align-items-center gap-2 text-nowrap">
                      <img
                        src="/assets/img/boc_mobile_new.svg"
                        alt="中國銀行(香港)"
                        className="d-block nav-boc-img"
                      />
                      &nbsp;呈獻&nbsp;
                    </div>
                    {/* Center logos */}
                    <div className="d-flex align-items-center justify-content-center">
                      <a href="/">
                        <img
                          src="/assets/img/logo.svg"
                          alt="Academy"
                          className="d-block nav-img"
                        />
                      </a>
                    </div>
                    {/* Mobile spacer to maintain balance */}
                    <div style={{ width: 60 }}></div>
                  </div>
                </div>
                {/* Second row: close button (left), LoginComponent (right) */}
                <div className="row align-items-center mb-2">
                  <div className="col-12 d-flex flex-row justify-content-between align-items-center">
                    <button
                      className="btn btn-link nav-toggle"
                      onClick={toggleMobileMenu}
                      style={{ fontSize: '1.5rem', color: '#FF831E' }}
                      aria-label="close menu"
                    >
                      ✕
                    </button>
                    <LoginComponent />
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid py-4" style={{ marginTop: '32%' }}>
              {/* Mobile nav links */}
              <div className="row">
                <div className="col-12">
                  <nav className="nav flex-column gap-4">
                    {links.map((link) => (
                      <a
                        key={link.to || link.children}
                        href={link.to}
                        className="nav-link py-3 d-flex align-items-center justify-content-center"
                        style={{
                          fontSize: '18px',
                          color: isActive(link.to) ? '#FF831E' : '#333',
                          fontWeight: isActive(link.to) ? 700 : 500,
                          cursor: 'pointer',
                        }}
                        onClick={link.onPress ? link.onPress : toggleMobileMenu}
                      >
                        <img
                          src={getIconSrc(link)}
                          alt={link.children}
                          style={{ width: 32, height: 32, marginRight: 8 }}
                        />
                        {link.children}
                      </a>
                    ))}
                  </nav>
                  {/* Logout link */}
                  <a
                    href="/logout"
                    className="nav-link py-3 d-flex align-items-center justify-content-center"
                    style={{
                      fontSize: '18px',
                      color: '#333',
                      textDecoration: 'none',
                    }}
                    onClick={toggleMobileMenu}
                  >
                    登出
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
